<script setup lang="ts">
import ModalInMiddle from "@/components/Modal/ModalInMiddle.vue";
import Tabbar from "@/components/Tabbar.vue";
import WaterFall from "@/components/WaterFall.vue";
import { ref } from "vue";
import { useRoute } from "vue-router";
const isShowConcertRetiredModal = ref<boolean>(false);
const isShowProductRetiredModal = ref<boolean>(false);
const isShowGiftModal = ref<boolean>(true);
const isShowDetailModal = ref<boolean>(false);
const integralActive = ref<boolean>(false);
const productCur = ref<number>(0);
const payTypeIndex = ref<number>(0);
const stepNumber = ref<number>(1);

const payTypeList = ref([
  "MUSDT",
  "Line Pay",
  "Kakao Pay",
  "PayPal",
  "Credit Card",
]);

const handleStep = (type: string) => {
  if (type === "+") {
    if (stepNumber.value >= 99) {
      return false;
    }
    stepNumber.value++;
  } else {
    if (stepNumber.value === 1) {
      return false;
    }
    stepNumber.value--;
  }
};


</script>

<template>
  <div class="order-detail-layout">
    <div class="body">
      <div class="product-info flex-row-between-center">
        <div class="left">
          <img src="../../assets/product-detail.png" alt="" />
        </div>
        <div class="right flex-col-between-start">
          <div class="title">
            Shenzhen丨2024 Zhou Xingzhe Odyssey (Journey) Tour -(Journey) Tour -
          </div>
          <!-- <div class="store-title flex-row-start-center">
            店铺标题店铺标题店铺标题 <span class="right-icon"></span>
          </div> -->
          <div class="store-address">
            地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点地点
          </div>
        </div>
      </div>
      <div class="order-sku">
        <p>2024.02.23 19:30</p>
        <p class="fs-12">$ <span class="number-font"> 688</span>票档 x1</p>
      </div>
      <div class="write-off flex-col-start-center">
        <p class="title">演唱会二维码</p>
        <div class="second-title">请给相关核票人员出示二维码</div>
        <div class="code-wrapper flex-col-center-center">
          <div class="flex-col-center-center">
            <div class="code">
              <img src="../../assets/qr-code.png" alt="" />
            </div>
            <p class="flex-row-start-center">
              32321321421421424<span class="copy-icon"></span>
            </p>
          </div>
        </div>
        <div class="btn-group flex-row-between-center">
          <div
            class="btn left flex-row-center-center"
            @click="isShowConcertRetiredModal = true"
          >
            退票
          </div>
          <div class="btn right flex-row-center-center"  @click="isShowGiftModal = true">转赠他人</div>
        </div>
      </div>
    </div>
    <ModalInMiddle
      v-model:is-show="isShowConcertRetiredModal"
      title="确定退票吗"
    >
      <div class="retired-modal">
        <p>退票后资金会在3个工作日内返回您的账户，该操作不可撤销，确定继续吗</p>
        <div class="btn-group flex-row-between-center">
          <div class="btn left flex-row-center-center">确定</div>
          <div
            class="btn right flex-row-center-center"
            @click="isShowConcertRetiredModal = false"
          >
            不是现在
          </div>
        </div>
      </div>
    </ModalInMiddle>
    <ModalInMiddle v-model:is-show="isShowProductRetiredModal" title="退款">
      <div class="retired-modal">
        <p>退款后资金会在3个工作日内返回您的账户，该操作不可撤销，确定继续吗</p>
        <div class="btn-group flex-row-between-center">
          <div class="btn left flex-row-center-center">确定</div>
          <div
            class="btn right flex-row-center-center"
            @click="isShowProductRetiredModal = false"
          >
            不是现在
          </div>
        </div>
      </div>
    </ModalInMiddle>
    <ModalInMiddle v-model:is-show="isShowGiftModal" title="转赠他人">
      <div class="gift-modal">
        <div class="inputer-wrapper">
          <p>输入接受人手机号</p>
          <div class="inputer number-font flex-row-start-center">
            +86 <span class="down-icon"></span>
            <input type="text" placeholder="000 0000 0000" />
          </div>
        </div>
        <div class="inputer-wrapper">
          <p>再次输入</p>
          <div class="inputer number-font flex-row-start-center">
            +86 <span class="down-icon"></span>
            <input type="text" placeholder="000 0000 0000" />
          </div>
        </div>
        <div class="tip flex-row-start-center">
          <span class="tip-icon"></span> 转赠后票会立即转给他人，该操作不可撤销
        </div>
        <div class="btn-group flex-col-center-center">
          <div class="confirm-btn flex-row-center-center">确认转赠</div>
          <div class="cancel-btn flex-row-center-center" @click="isShowGiftModal = false">取消</div>
        </div>
      </div>
    </ModalInMiddle>
  </div>
</template>

<style lang="scss" scoped>
.order-detail-layout {
  height: 100%;
  min-height: 100vh;
  background: #000;

  .body {
    padding: 14px 16px;
    color: #fff;
    /* height: calc(100vh - 174px); */
    /* overflow-y: scroll; */
    .product-info {
      height: 122px;
      gap: 12px;
      .left {
        img {
          width: 96px;
          height: 122px;
          border-radius: 12px;
          background: #d9d9d9;
          object-fit: cover;
        }
      }
      .right {
        height: 100%;
        .title {
          font-size: 14px;
          line-height: 1.6;
          .tag {
            font-size: 8px;
            display: inline-flex;
            padding: 3px 4px;
            justify-content: center;
            align-items: center;
            bottom: 2px;
            gap: 2px;
            border-radius: 4px;
            margin-right: 6px;
            background: linear-gradient(
              224deg,
              #eaadff 0%,
              #efdbff 44.6%,
              #76d6ff 98.01%
            );
          }
        }
        .store-title {
          font-size: 12px;
          .right-icon {
            width: 16px;
            height: 16px;
            background: url(../../assets/right-icon-white.svg);
            background-repeat: no-repeat;
            background-size: contain;
            margin-left: 4px;
          }
        }
        .store-address {
          line-height: 1.2;
          font-size: 11px;
          color: #565662;
          overflow: hidden;
          text-overflow: ellipsis;
          /* 将对象作为弹性伸缩盒子模型显示 */
          display: -webkit-box;
          /* 限制在一个块元素显示的文本的行数 */
          /* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
          -webkit-line-clamp: 2;
          /* 设置或检索伸缩盒对象的子元素的排列方式 */
          -webkit-box-orient: vertical;
        }
        .price {
          color: #ff3456;
          font-size: 21px;
          .coin {
            font-size: 12px;
            margin-right: 2px;
          }
        }
      }
    }
    .order-sku {
      padding: 12px 0;
      border-top: 1px solid rgba($color: #eee, $alpha: 0.1);
      margin-top: 12px;
      font-size: 16px;
      color: #fff;
      line-height: 1.6;
      .number-font {
        font-size: 16px;
      }
    }
    .write-off {
      position: relative;
      width: 100%;
      height: 474px;
      background: url(../../assets/order-card.png);
      background-size: cover;
      background-repeat: no-repeat;
      padding: 24px 32px;
      border-radius: 16px;
      color: #565662;
      font-size: 12px;
      .title {
        font-size: 21px;
        color: #070b14;
        line-height: 1.8;
        font-weight: 700;
      }
      .second-title {
        font-size: 12px;
        color: #9c9caa;
      }
      .code-wrapper {
        width: 287px;
        height: 287px;
        border-radius: 16px;
        background: #fff;
        margin-top: 28px;
        font-size: 12px;
        font-weight: 400;
        color: #565662;
        .code {
          width: 145.711px;
          height: 145.711px;
          padding: 8px;
          margin-bottom: 8px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .copy-icon {
          width: 16px;
          height: 16px;
          background: url(../../assets/copy-icon.svg);
          background-size: contain;
          background-repeat: no-repeat;
          margin-left: 4px;
        }
      }
      .btn-group {
        width: 100%;
        gap: 13px;
        margin-top: 28px;
        .btn {
          width: 100%;
          height: 40px;
          font-size: 16px;
          font-weight: 500;
          border-radius: 8px;
          &.left {
            color: #e43f5a;
            border: 1px solid #e43f5a;
          }
          &.right {
            color: #070b14;
            background: linear-gradient(
              111deg,
              #fff853 4.98%,
              #6eef94 56.05%,
              #2ad8cd 95.37%
            );
          }
        }
      }
    }
  }
}
.retired-modal {
  .btn-group {
    width: 100%;
    gap: 13px;
    margin-top: 24px;
    .btn {
      width: 100%;
      height: 40px;
      font-size: 16px;
      font-weight: 500;
      border-radius: 8px;
      &.left {
        color: #9c9caa;
        border: 1px solid #9c9caa;
      }
      &.right {
        color: #070b14;
        background: linear-gradient(
          111deg,
          #fff853 4.98%,
          #6eef94 56.05%,
          #2ad8cd 95.37%
        );
      }
    }
  }
}
.gift-modal {
  .inputer-wrapper {
    font-size: 12px;
    color: #999999;
    margin-bottom: 16px;
    .inputer {
      width: 100%;
      height: 50px;
      font-size: 14px;
      border-radius: 9px;
      background: #1f212d;
      padding: 16px;
      color: #fff;
      margin-top: 4px;
      .down-icon {
        width: 16px;
        height: 16px;
        background: url(../../assets/back-icon-white.svg);
        transform: rotate(-90deg);
        background-size: contain;
        background-repeat: no-repeat;
        margin-left: 8px;
      }
      input {
        text-align: right;
        font-size: 14px;
        font-weight: 700;
        color: #fff;
        &::placeholder {
          color: #565662;
        }
      }
    }
  }
  .tip {
    font-size: 12px;
    color: #ff3456;
    .tip-icon {
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url(../../assets/tip-icon.svg);
      background-size: contain;
      background-repeat: no-repeat;
      margin-right: 2px;
    }
  }
  .btn-group {
    margin-top: 14px;
    .confirm-btn {
      width: 100%;
      height: 48px;
      border-radius: 12px;
      background: linear-gradient(
        111deg,
        #fff853 4.98%,
        #6eef94 56.05%,
        #2ad8cd 95.37%
      );
      color: #070B14;
      font-size: 16px;
    }
    .cancel-btn{
      width: 100%;
      height: 48px;
      font-size: 16px;
      color: #999;
    }
  }
}
</style>
